import {callAPI} from '@/store/utils'; // eslint-disable-line
import {base} from './utils';

// Bank-account activation (class 5 / 512): per synced bank account, whether
// Okimia generates bank-journal entries for it. Activating provisions the
// 512xxx ledger account. Backs the "comptes bancaires" section of the Journal
// de banque settings. Composed into the `accounting` namespace by ./index.js.
// See the API contract in TT-7122 (§4).
export default {
  state: {
    bankAccounts: [],
    bankAccountsLoaded: false,
  },
  getters: {
    bankAccounts: (state) => state.bankAccounts,
    bankAccountsLoaded: (state) => state.bankAccountsLoaded,
  },
  mutations: {
    setBankAccounts(state, list) {
      state.bankAccounts = list || [];
      state.bankAccountsLoaded = true;
    },
    // Patch a single account's activation state locally (no refetch). The toggle
    // is derived from the linkage, so we only carry is_activated + the 512
    // number back into the row.
    setBankAccountActivation(
      state,
      {accountId, isActivated, ledgerAccountNumber},
    ) {
      const i = state.bankAccounts.findIndex(
        (a) => String(a.account_id) === String(accountId),
      );
      if (i === -1) return;
      state.bankAccounts.splice(i, 1, {
        ...state.bankAccounts[i],
        is_activated: isActivated,
        ledger_account_number: ledgerAccountNumber,
      });
    },
  },
  actions: {
    async actionGetBankAccounts({commit}) {
      const res = await callAPI('GET', `${base()}/bank-accounts`);
      if (res && !res.error) commit('setBankAccounts', res.result);
      return res;
    },
    async actionActivateBankAccount({commit}, {accountId}) {
      const res = await callAPI(
        'POST',
        `${base()}/bank-accounts/${accountId}/activate`,
      );
      if (res && !res.error) {
        commit('setBankAccountActivation', {
          accountId,
          isActivated: true,
          ledgerAccountNumber: res.result?.account_number || null,
        });
      }
      return res;
    },
    async actionDeactivateBankAccount({commit}, {accountId}) {
      const res = await callAPI(
        'POST',
        `${base()}/bank-accounts/${accountId}/deactivate`,
      );
      if (res && !res.error) {
        commit('setBankAccountActivation', {
          accountId,
          isActivated: false,
          ledgerAccountNumber: null,
        });
      }
      return res;
    },
  },
};
